// 过滤地块方法
function filterLand(list, filterObj) {
  const { cropGroupId, landGroupIdArray, landName } = filterObj;
  let temp = list;
  if (cropGroupId !== null) {
    temp = [];
    if (cropGroupId === "empty") {
      // 筛选空闲地块
      temp = list.filter((ele) => ele.cropList && !ele.cropList.length);
    } else {
      list.filter((item) => {
        if (item.cropList) {
          item.cropList.forEach((m) => {
            if (m.cropId == cropGroupId) {
              const arr = temp.map((list) => list.id);
              !arr.includes(item.id) && temp.push(item);
            }
            return;
          });
        }
      });
    }
  }
  if (landGroupIdArray.length) {
    temp = temp.filter((item) => landGroupIdArray.includes(item.landGroupId));
  }
  if (landName && landName !== "空闲地块") {
    temp = temp.filter((item) => item.landName.includes(landName));
  }
  return temp;
}

export default {
  namespaced: true,
  state: {
    showLandMode: "ListMode", // 地块显示模式
    landLoading: true, // 地块查询 loading
    landList: [], // 用于页面展示的数据
    filterLandCondition: null, // 过滤地块的条件
    isSearch: false,
    closeOpen: true,
  },
  getters: {
    // 页面展示的地块数据
    showLandList(state) {
      if (state.filterLandCondition == null) {
        return state.landList;
      } else {
        return filterLand(state.landList, state.filterLandCondition);
      }
    },
    // 已经选中的列表
    hadSelectedLandList(state) {
      return state.landList.filter((land) => land.select);
    },
    // 判断是否全选中地块
    isSelectAllLand(state, getters) {
      const flagTrueList = getters.showLandList.filter(
        (land) => !land.selectableFlag
      );
      if (flagTrueList.length) {
        return flagTrueList.every((item) => item.select);
      } else {
        return false;
      }
    },
    // 用于渲染地图模式数据
    renderMapData(state, getters) {
      return getters.showLandList.map((item) => {
        const obj = item.coLandVO;
        obj.cropList = [item.coCropVO];
        obj.select = item.select;
        obj.disable = item.selectableFlag;
        return obj;
      });
    },
  },
  mutations: {
    // 重置页面的状态
    clearPageAllStatus(state) {
      state.filterLandCondition = null;
      state.showLandMode = "ListMode";
      state.landList = [];
      state.landLoading = true;
    },
    // 修改地块显示模式
    changeShowLandMode(state, mode) {
      state.showLandMode = mode;
    },
    //弹框是否关闭
    closeLand(state, flag) {
      state.closeOpen = flag;
    },
    // 过滤地块信息
    filterLandList(state, obj) {
      if (!obj) {
        state.filterLandCondition = null;
        return;
      }
      const { cropGroupId, landGroupIdArray, landName } = obj;
      state.filterLandCondition = {
        cropGroupId,
        landGroupIdArray,
        landName,
      };
      state.isSearch = true;
    },
    removeSearchState(state) {
      state.isSearch = false;
    },
    // 设置所有地块数据
    setLandList(state, data) {
      state.landList = data;
    },
    // 改变选中状态
    changeSelectStatus(state, id) {
      state.landList = state.landList.map((item) => {
        if (item.id == id) {
          item.select = !item.select;
        }
        return item;
      });
    },
    // 全选（始终在原数据上修改，然后通过 getters 分发）
    selectAllLand(state, data) {
      const { selectStatus, showLandList } = data;
      const landIds = showLandList.map((item) => item.id);
      const temp_list = state.landList;
      temp_list.forEach((land) => {
        if (!land.selectableFlag && landIds.includes(land.id)) {
          land.select = selectStatus;
        }
      });
      state.landList = temp_list;
    },
    // loading 状态
    changeLoadingStatus(state, status) {
      state.landLoading = status;
    },
  },
};
